class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
  this.productId = parsedState.id;

  // 1. Render the new item instantly from parsedState (no extra fetch needed)
  const image = parsedState.featured_image?.url
    ? `<img class="cart-notification-product__image" src="${parsedState.featured_image.url}" alt="" width="119" height="123" loading="lazy">`
    : `<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">`;

  const option = parsedState.options_with_values?.[0];
  const htm = `
    <div class="row-cart">
      ${image}
      <a href="javascript:void(0)" class="removeitem" data-variant-id="${parsedState.id}">X Remove</a>
      <div class="cart_item_content">
        <a href="${parsedState.url}">
          <h3 class="cart-notification-product__name h4">${parsedState.product_title}</h3>
        </a>
        <dl>
          ${option ? `<div class="product-option bhc-${option.value}">
            <dt>${option.name}: </dt><dd>${option.value}</dd>
          </div>` : ''}
          <div class="product-option"><dt>Qty: </dt><dd>${parsedState.quantity}</dd></div>
        </dl>
      </div>
    </div>`;

  $('#cart-notification-product').html(htm);

  // 2. Open the drawer immediately — product is already visible
  if (this.header) this.header.reveal();
  this.open();

  // 3. Fetch full cart in the background to update totals, count, ALL items, and shipping bar
  $.getJSON('/cart.js').then(cart => {
    // Re-render all items (handles multiple items in cart)
    let fullHtm = '';
    cart.items.forEach(function(item) {
      const img = item?.featured_image?.url
        ? `<img class="cart-notification-product__image" src="${item.featured_image.url}" alt="" width="119" height="123" loading="lazy">`
        : `<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">`;
      fullHtm += `<div class="row-cart">
        ${img}
        <a href="javascript:void(0)" class="removeitem" data-variant-id="${item.id}">X Remove</a>
        <div class="cart_item_content">
          <a href="${item.url}">
            <h3 class="cart-notification-product__name h4">${item.product_title}</h3>
          </a>
          <dl>
            <div class="product-option bhc-${item.options_with_values[0].value}">
              <dt>${item.options_with_values[0].name}: </dt><dd>${item.options_with_values[0].value}</dd>
            </div>
            <div class="product-option"><dt>Qty: </dt><dd>${item.quantity}</dd></div>
          </dl>
        </div>
      </div>`;
    });
    $('#cart-notification-product').html(fullHtm);

    const total = (cart.total_price / 100).toFixed(2);
    $('.mini-cart-total-price span').text(`$${total} AUD`);
    $('.cart-count-bubble span').html(`(${cart.item_count})`);
    $('.point-to-icon').addClass('animate active');
    $('body').addClass('drawer--open');
    $('.overlay_body').show();

    if (cart.items.length === 0) {
      $('div#cart-notification .cart-notification__links').hide();
      $('.cartempty').show();
    } else {
      $('.cartempty').hide();
      $('div#cart-notification .cart-notification__links').show();
    }

    $.get('/cart?view=cart_free_shipping', function(pro) {
      $('.productshippingbar').html(pro);
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.log('getJSON request failed! ' + textStatus);
    });
  }).fail(function(err) {
    console.log(err);
  });
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
